/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_home_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. Most tools, including the Percentage Calculators and the core F1 Fantasy pages, work without signing in. An account is only needed for a few personalized features, like saving your Apex Team lineup or unlocking certain locked predictions faster — and creating one takes under a minute.`)
};

const es_home_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. La mayoría de las herramientas, incluidas las Calculadoras de Porcentajes y las páginas principales de F1 Fantasy, funcionan sin iniciar sesión. Solo se necesita una cuenta para algunas funciones personalizadas, como guardar tu alineación de Apex Team o desbloquear ciertas predicciones bloqueadas más rápido — y crear una lleva menos de un minuto.`)
};

const de_home_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nein. Die meisten Werkzeuge, einschließlich der Prozentrechner und der zentralen F1-Fantasy-Seiten, funktionieren ohne Anmeldung. Ein Konto wird nur für ein paar personalisierte Funktionen benötigt, etwa um dein Apex-Team-Lineup zu speichern oder bestimmte gesperrte Prognosen schneller freizuschalten — und die Erstellung dauert unter einer Minute.`)
};

const nl_home_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nee. De meeste tools, inclusief de Percentage Calculators en de belangrijkste F1 Fantasy-pagina's, werken zonder in te loggen. Een account is alleen nodig voor een paar gepersonaliseerde functies, zoals het opslaan van je Apex Team-opstelling of het sneller ontgrendelen van bepaalde vergrendelde voorspellingen — en een account aanmaken duurt minder dan een minuut.`)
};

const fr_home_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non. La plupart des outils, y compris les calculateurs de pourcentage et les pages principales de F1 Fantasy, fonctionnent sans connexion. Un compte n’est nécessaire que pour quelques fonctionnalités personnalisées, comme sauvegarder votre composition Équipe Apex ou débloquer plus rapidement certaines prédictions verrouillées — et en créer un prend moins d’une minute.`)
};

const it_home_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. La maggior parte degli strumenti, inclusi i Calcolatori Percentuali e le pagine principali di F1 Fantasy, funzionano senza accedere. Un account serve solo per alcune funzionalità personalizzate, come salvare la formazione del tuo Team Apex o sbloccare più rapidamente certe previsioni bloccate — e crearne uno richiede meno di un minuto.`)
};

const pt_br2_home_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não. A maioria das ferramentas, incluindo as Calculadoras de Porcentagem e as páginas principais de F1 Fantasy, funciona sem login. Uma conta só é necessária para alguns recursos personalizados, como salvar sua escalação da Equipe Apex ou desbloquear certas previsões mais rápido — e criar uma leva menos de um minuto.`)
};

const pt_home_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não. A maioria das ferramentas, incluindo as Calculadoras de Percentagem e as páginas principais de F1 Fantasy, funcionam sem iniciar sessão. Uma conta só é necessária para algumas funcionalidades personalizadas, como guardar a sua formação do Apex Team ou desbloquear certas previsões bloqueadas mais rapidamente — e criar uma demora menos de um minuto.`)
};

const ja_home_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いいえ。Percentage Calculatorsや主要なF1ファンタジーページを含むほとんどのツールは、サインインなしで利用できます。アカウントが必要になるのは、Apexチームのラインナップを保存したり、ロックされた一部の予測をより早くアンロックしたりといった、いくつかのパーソナライズ機能のみです。作成にかかる時間は1分もかかりません。`)
};

const zh_home_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不需要。大多数工具（包括百分比计算器和核心的 F1 Fantasy 页面）无需登录即可使用。只有少数个性化功能才需要账户，比如保存你的 Apex Team 阵容或更快解锁某些锁定的预测——注册也只需不到一分钟。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const home_faq2_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.home_faq2_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("home_faq2_a", locale)
	if (locale === "en") return en_home_faq2_a(inputs)
	if (locale === "es") return es_home_faq2_a(inputs)
	if (locale === "de") return de_home_faq2_a(inputs)
	if (locale === "nl") return nl_home_faq2_a(inputs)
	if (locale === "fr") return fr_home_faq2_a(inputs)
	if (locale === "it") return it_home_faq2_a(inputs)
	if (locale === "pt-BR") return pt_br2_home_faq2_a(inputs)
	if (locale === "pt") return pt_home_faq2_a(inputs)
	if (locale === "ja") return ja_home_faq2_a(inputs)
	return zh_home_faq2_a(inputs)
};